import { Checkbox, Table } from '../../components';
import { builtinData } from '../../data';

import React from 'react';
import {
  find,
  groupBy,
  map,
  mapValues,
  pick,
  sortBy,
  sumBy,
  uniq,
} from 'lodash';

const AgeGroupsPicker = ({ actions, meta }) => {
  const ageGroupsByBundle = groupBy(meta.ageGroups, 'bundle');
  return (
    <Table collapsing basic="very">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell />
          <Table.HeaderCell>Bundle</Table.HeaderCell>
          {meta.genders.map(({ id, title }) => (
            <Table.HeaderCell key={id}>{title}</Table.HeaderCell>
          ))}
          <Table.HeaderCell>State</Table.HeaderCell>
          <Table.HeaderCell>Entries</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {map(ageGroupsByBundle, (ageGroups, bundle) => {
          const findContest = pattern => find(meta.contests, pattern);

          const contests = builtinData.contests
            .filter(({ ageGroup }) => find(ageGroups, { uuid: ageGroup }))
            .map(({ ageGroup, bodyweightCategory, ...props }) => ({
              ...props,
              ageGroup: find(meta.ageGroups, { uuid: ageGroup }),
              bodyweightCategory: find(meta.bodyweightCategories, {
                uuid: bodyweightCategory,
              }),
            }));

          const patterns = contests.map(contest =>
            mapValues(
              pick(contest, ['ageGroup', 'bodyweightCategory']),
              props => pick(props, 'id'),
            ),
          );

          const bodyweightCategories = sortBy(
            contests.map(({ bodyweightCategory }) => bodyweightCategory),
            'order',
          );
          const bodyweightCategoriesByGender = groupBy(
            bodyweightCategories,
            'gender.id',
          );

          const enabledContests = patterns.map(findContest).filter(Boolean);
          const isEnabled = enabledContests.length > 0;
          const isDisabled = !isEnabled;

          const entriesCount = sumBy(enabledContests, 'entries.length');
          const isEmpty = entriesCount <= 0;

          const disable = () =>
            patterns
              .map(findContest)
              .filter(Boolean)
              .forEach(({ primaryKey }) => actions.contest.destroy(primaryKey));
          const enable = () =>
            contests.forEach(({ ageGroup, bodyweightCategory, ...props }) =>
              actions.contest.upsert({
                ...props,
                ...mapValues({ ageGroup, bodyweightCategory }, 'primaryKey'),
              }),
            );

          const onToggleChange = (event, { checked }) => {
            checked ? enable() : disable();
          };

          return (
            <Table.Row key={bundle} positive={!isEmpty}>
              <Table.Cell>
                <Checkbox
                  toggle
                  disabled={!isEmpty}
                  checked={isEnabled}
                  onChange={onToggleChange}
                />
              </Table.Cell>
              <Table.Cell disabled={isDisabled}>{bundle}</Table.Cell>
              {meta.genders.map(({ id, title }) => (
                <Table.Cell key={id} disabled={isDisabled}>
                  {uniq(
                    map(
                      bodyweightCategoriesByGender[id],
                      ({ abbreviation }) => abbreviation,
                    ),
                  ).join(', ')}
                </Table.Cell>
              ))}
              <Table.Cell disabled={isDisabled}>
                {isEnabled ? 'Enabled' : 'Disabled'}
              </Table.Cell>
              <Table.Cell disabled={isDisabled}>
                {isEmpty ? '0' : <strong>{entriesCount}</strong>}
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

export default AgeGroupsPicker;



// WEBPACK FOOTER //
// ./src/pages/Setup/AgeGroupsPicker.js